import React from 'react';
import * as actCustomerList from 'actions/customers/list';
import { connect } from 'react-redux';
import {
  doImportCustomer,
  showModalImport,
  showModalErrorImport,
} from 'actions/uploaders';
import LoadingSpinner from 'components/LoadingSpinner';
import {
  ContentWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
  PageWrapper,
} from 'components/wrappers/pages';
import withFeatureFlags from 'hocs/withFeatureFlags';
import List from './List';
import ActionBar from './ActionBar';
import ImportModal from './importModal';
import ImportModalError from './importModalError';
import ImportingModeModal from './ImportingModeModal';
import Summary from './Summary';
import CustomerDetail from './CustomerDetail';

class ListLoyalty extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showDetail: false };
  }

  render() {
    const {
      showModalImport,
      showModalErrorImport,
      messageError,
    } = this.props.data.uploaders.import;
    const { showLoadingButton } = this.props.data.buttons;
    const { showLoadingSpinnerPage } = this.props.data.loadingSpinner;
    const { summary } = this.props.data.customers.list;

    const {
      loyaltySubscription: { subscriptionDetail },
    } = this.props;
    const detailBasic = subscriptionDetail.Loyalty;
    const detailPro = subscriptionDetail['Loyalty Pro'];

    const loyaltyMemberTotal = summary.total_loyalty_member;
    const remainingQuota = detailPro.is_active
      ? -1
      : Math.max(
          parseInt(detailBasic.properties.LOYALTY_MEMBER_LIMIT) -
            loyaltyMemberTotal,
          0
        );

    return (
      <PageWrapper>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport}
          onChangeKeyword={this._onChangeKeyword}
          onChangeType={this._onChangeType}
          loyaltySubscription={this.props.loyaltySubscription}
          goToSubscribeView={this.props.goToSubscribeView}
        />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={this.state.showDetail}>
            <Summary
              nonLoyaltyMemberTotal={
                summary.total_customer - summary.total_loyalty_member
              }
              loyaltyMemberTotal={summary.total_loyalty_member}
              remainingQuota={remainingQuota}
              rewardsTotal={summary.total_rewards_redeemed}
            />
            <div style={{ top: '116px', position: 'relative' }}>
              <LoadingSpinner showLoadingSpinner={showLoadingSpinnerPage} />
            </div>
            <List
              showDetail={this._showDetail}
              closeDetail={this._closeDetail}
            />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={this.state.showDetail}>
            <CustomerDetail
              onClickDone={this._closeDetail}
              showRedeemHistory={this.props.showRedeemHistory}
              showPurchaseHistory={this.props.showPurchaseHistory}
              showPointActivity={this.props.showPointActivity}
            />
          </RightColumnWrapper>
        </ContentWrapper>
        <ImportModal
          onShow={showModalImport}
          onHide={this._onClickCancelImport}
          onUpload={this._onClickUploadButton}
          showLoadingButton={showLoadingButton}
          onClickDownloadTemplate={this._onClickDownloadTemplate}
        />
        <ImportModalError
          onShow={showModalErrorImport}
          messageError={messageError}
          onClickTryBtn={this._onClickTryBtn}
          onClickCancelBtnError={this._onClickCancelBtnError}
        />
        <ImportingModeModal />
      </PageWrapper>
    );
  }

  _showDetail = () => {
    this.setState({ showDetail: true });
  };

  _closeDetail = () => {
    this.setState({ showDetail: false });
  };

  _onClickTryBtn = () => {
    this.props.dispatch(showModalImport(true));
    this.props.dispatch(showModalErrorImport(false, []));
  };

  _onClickCancelBtnError = () => {
    this.props.dispatch(showModalImport(false));
    this.props.dispatch(showModalErrorImport(false, []));
  };

  _onClickExport = () => {
    const { enableCustomerExportTemplate, data } = this.props;
    const { hasLoyalty } = data.customers.list;

    if (enableCustomerExportTemplate) {
      this.props.dispatch(
        actCustomerList.downloadCustomerExportTemplate(hasLoyalty)
      );
    } else {
      const userEmail = data.moka.user.email;
      const filename = `Customer List - ${userEmail}`;
      this.props.dispatch(
        actCustomerList.customerExportRequest(filename, hasLoyalty)
      );
    }
  };

  _onChangeKeyword = keyword => {
    this.props.dispatch(
      actCustomerList.customersRequest(
        {
          page: 1,
          keyword,
          type: this.props.data.customers.list.type,
        },
        []
      )
    );
    this._closeDetail();
  };

  _onChangeType = type => {
    this.props.dispatch(
      actCustomerList.customersRequest(
        {
          page: 1,
          keyword: this.props.data.customers.list.keyword,
          type,
        },
        []
      )
    );
    this._closeDetail();
  };

  _onClickImport = () => {
    this.props.dispatch(showModalImport(true));
  };

  _onClickCancelImport = () => {
    this.props.dispatch(showModalImport(false));
  };

  _onClickUploadButton = file => {
    this.props.dispatch(doImportCustomer(file, true));
  };

  _onClickDownloadTemplate = () => {
    const userEmail = this.props.data.moka.user.email;
    const filename = `Customer List - ${userEmail}`;
    this.props.dispatch(actCustomerList.downloadCustomerTemplate(filename));
  };
}

function mapStateToProps(state) {
  return {
    data: state,
  };
}

const mapFlagsToProps = flags => ({
  enableCustomerExportTemplate: flags.enableCustomerExportTemplate,
});

export default withFeatureFlags(mapFlagsToProps)(
  connect(mapStateToProps)(ListLoyalty)
);
